import LazyVideo from 'components/common/LazyVideo'
import SanityBlock from 'components/common/SanityBlock'
import React from 'react'

export default function VideoBlock({ _rawIntro, video }) {
	if (!video) return null

	return (
		<section className="ctnr padding space-y-12 text-center">
			{_rawIntro && (
				<header className="richtext mx-auto max-w-screen-md text-lg">
					<SanityBlock body={_rawIntro} />
				</header>
			)}

			{video?.url ? (
				<iframe
					className="aspect-video w-full"
					src={video.url}
					title={video.url}
				/>
			) : (
				video?.filename && <LazyVideo {...video} />
			)}
		</section>
	)
}
